import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  padding: 12px 16px;
  border: 2px solid var(--color-light-gray);
  font-size: 1rem;
  transition: border-color 0.2s ease;
  border-radius: 0;
  width: 100%;
  
  &:focus {
    outline: none;
    border-color: var(--color-blue);
  }
  
  &::placeholder {
    color: var(--color-gray);
  }
`;

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <StyledInput
        className={className}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';
